
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[n]",
      function () {
        return require("private-next-pages/blog/page/[n].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[n]"])
      });
    }
  